<template>
  <b-field
    :label="label"
    :type="(hasError() ? 'is-danger': '')"
    :message="errorMessage()"
  >
    <tag-fetch
      :value="formattedValue"
      :icon="icon"
      :placeholder="placeholder"
      :field="field"
      :maxtags="maxtags"
      :has-counter="hasCounter"
      :maxlength="maxlength"
      :route="route"
      :open-on-focus="openOnFocus"
      :keep-first="keepFirst"
      @input="onInput"
      @typing="onTyping"
    />
  </b-field>
</template>

<script>
import InputBase from "./InputBase";
import TagFetch from "../components/TagFetch";

export default {
  components: {
    TagFetch
  },
  extends: InputBase,
  props: {
    value: {
      required: true
    },
    route: {
      required: true,
      type: String
    },
    field: {
      default: undefined,
      type: String
    },
    icon: {
      default: "label",
      type: String
    },
    maxtags: {
      type: Number,
      default: undefined
    },
    maxlength: {
      type: Number,
      default: undefined
    },
    openOnFocus: {
      type: Boolean,
      default: false
    },
    keepFirst: {
      type: Boolean,
      default: true
    },
    hasCounter: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    formattedValue () {
      return _.isArray(this.value) ? this.value : [];
    }
  },
  methods: {
    onTyping (query) {
      this.$emit("typing", query);
    },
    onInput (event) {
      this.inputListener(event);
    }
  }
};
</script>
